export default defineNuxtRouteMiddleware(async (to) => {
  // 로그인 페이지에서는 실행하지 않음
  if (to.path === '/login' || to.path.startsWith('/screens/common/login')) {
    return;
  }

  const { $pinia } = useNuxtApp();

  if (process.client && $pinia) {
    const { useAuthStore } = await import('~/stores/useAuthStore');
    const { useUserImgsStore } = await import('~/composables/useUserImgsStore');

    const authStore = useAuthStore($pinia);
    const userImgsStore = useUserImgsStore($pinia);

    // 로그인된 사용자가 있고 이미지가 초기화되지 않은 경우에만 실행
    if (authStore.isLoggedIn && authStore.user && !userImgsStore.isInitialized) {
      console.log('Middleware: Initializing user images for user:', authStore.user.userId);
      try {
        // 매니저 대시보드의 데이터 조회는 프로필 이미지 목록에 의존하지 않는다.
        // 이미지 응답이 늦어도 화면 진입과 조직도/캘린더 조회를 시작할 수 있게 한다.
        const isManagerDashboard = /^\/(?:screens\/)?dashboard\/manager(?:\/|$)/.test(to.path);
        if (isManagerDashboard) {
          void userImgsStore.initializeUserImages().catch(error => {
            console.warn('Middleware: Failed to initialize user images:', error);
          });
          console.log('Middleware: User image initialization started in background');
        } else {
          await userImgsStore.initializeUserImages();
          console.log('Middleware: User images initialized successfully');
        }
      } catch (error) {
        console.warn('Middleware: Failed to initialize user images:', error);
      }
    }
  }
});
